import React from 'react';
import { Card, CardHeader, Box } from '@mui/material';
import { Player } from '../../state/reduxRepositories/players/player.interfaces';
import { getInitials } from '../../helpers/initialsExtractor';
import { Avatar } from '../avatar/avatar';

interface PlayerCardNameOnlyProps {
  player: Player;
}

export function PlayerCardNameOnly({ player }: PlayerCardNameOnlyProps) {
  return (
    <Box
      sx={{
        '&:hover': {
          cursor: 'pointer',
        },
      }}
    >
      <Card sx={{ borderRadius: 4 }}>
        <CardHeader
          avatar={
            <Avatar
              title={getInitials(`${player.firstName} ${player.lastName}`)}
            />
          }
          title={`${player.firstName} ${player.lastName}`}
          titleTypographyProps={{ variant: 'h6' }}
        />
      </Card>
    </Box>
  );
}
